import Header from "@/reusable_sections/Header";
import IgnitingYourVision from "./sections/IgnitingYourVision";
import Services from "./sections/Services";
import MasterpiecesInProgress from "./sections/MasterpiecesInProgress";
import HowItWorks from "./sections/HowItWorks";
import VoicesOfSatisfaction from "./sections/VoicesOfSatisfaction";
import CtaBand from "@/components/CtaBand";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <IgnitingYourVision />
      <Services />
      <MasterpiecesInProgress />
      <HowItWorks />
      <VoicesOfSatisfaction />
      <CtaBand title="Tell us about your project" text="Book a visit, or call and talk to us directly." />
      <Footer />
    </div>;
}